
import { BasicController } from "@goodgamestudios/core";
import { TimeStringHelper } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { BasicComboboxEvent } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { BasicCustomCursor } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { SFConstants } from "../../../constants/SFConstants";
import { Poker2RankingDataEvent } from "../../../event/Poker2RankingDataEvent";
import { TournamentRankingVO } from "../../../gamevo/TournamentRankingVO";
import { Poker2Model } from "../../../model/Poker2Model";

import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;

export class Poker2RankingTabTunier {
    private MAX_RANKINGLINES: number = 7;

    private disp: MovieClip;	//	rankingDialog.mc_tunier
    private selectedLine: Library.PokerInterface.RankingTunierLine;
    public monthComboBox: Poker2DynamicCombobox;
    public yearComboBox: Poker2DynamicCombobox;
    private currentDate: Date = new Date();

    private selectedTournament: number = -1;

    /**
     * @param disp
     * @param monthHallComboBox
     */
    constructor(disp: MovieClip) {
        this.disp = disp;
        this.monthComboBox = new Poker2DynamicCombobox(disp.combo_month);
        this.yearComboBox = new Poker2DynamicCombobox(disp.combo_year);
    }

    public applyProperties(): void {
        this.disp.txt_sortrank.mouseEnabled = false;
        this.disp.txt_sortfirst.mouseEnabled = false;
        this.disp.txt_sortsecound.mouseEnabled = false;
        this.disp.txt_sortthird.mouseEnabled = false;
        this.initTextFields();
        Poker2RankingDialog.setMonthComboBox(this.monthComboBox, this.yearComboBox);
    }

    public initTextFields(): void {
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_sortrank,
            Poker2Model.languageData.getTextById("dialog_ranking_date"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_sortfirst,
            Poker2Model.languageData.getTextById("dialog_ranking_first"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_sortsecound,
            Poker2Model.languageData.getTextById("dialog_ranking_second"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_sortthird,
            Poker2Model.languageData.getTextById("dialog_ranking_third"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_month,
            Poker2Model.languageData.getTextById("dialog_ranking_month"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_year,
            Poker2Model.languageData.getTextById("dialog_ranking_year"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.disp.txt_title,
            Poker2Model.languageData.getTextById("dialog_ranking_tournament_title"));
    }

    public show(): void {
        Poker2RankingDialog.setMonthComboBox(this.monthComboBox, this.yearComboBox);
        this.monthComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onMonthComboboxChange));
        this.yearComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onYearComboboxChange));
        this.controller.addEventListener("changeJoustRankingData", this.bindFunction(this.onChangeJoustRankingData));
    }
    public hide(): void {
        this.monthComboBox.disp.removeEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onMonthComboboxChange));
        this.yearComboBox.disp.removeEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onYearComboboxChange));
        this.controller.removeEventListener("changeJoustRankingData", this.bindFunction(this.onChangeJoustRankingData));
    }
    private onYearComboboxChange(event: BasicComboboxEvent): void {
        this.yearComboBox.disp.removeEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onYearComboboxChange));

        var yearSort: number = int(this.yearComboBox.selectedId + 2011);
        Poker2RankingDialog.setMonthComboBox(this.monthComboBox, this.yearComboBox, -1, yearSort);

        this.yearComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onYearComboboxChange));
    }
    private onMonthComboboxChange(event: BasicComboboxEvent): void {
        this.getListFromServer(-1);
    }
    private onChangeJoustRankingData(event: Poker2RankingDataEvent): void {
        this.fillTournamentRanking(Poker2Model.rankingData.tournamentRankList);
    }

    public onClick(event: MouseEvent): void {
        var tunierLine: Library.PokerInterface.RankingTunierLine;

        switch (event.target) {
            case this.disp.btn_up:
                if (event.target.properties > 1) {
                    var firstR: number = int(event.target.properties - this.MAX_RANKINGLINES);
                    if (firstR < 0)
                        firstR = 1;
                    this.getListFromServer(firstR, this.selectedTournament);
                }
                break;
            case this.disp.btn_down:
                this.getListFromServer(event.target.properties, this.selectedTournament);
                break;
            default:
                if (instanceOfClass(event.target, "RankingTunierLine")) {
                    tunierLine = event.target as Library.PokerInterface.RankingTunierLine;
                    this.selectedTournament = int(tunierLine.properties);
                    this.activateTournamentRankLine(tunierLine);
                    this.getListFromServer(this.disp.btn_up.properties, this.selectedTournament);
                }
                break;
        }
    }

    public onMouseOver(event: MouseEvent): void {
        if (event.target != this.selectedLine)
            (event.target as Library.PokerInterface.RankingTunierLine).mc_background.gotoAndStop(2);
        this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);
    }

    public onMouseOut(event: MouseEvent): void {
        if (event.target != this.selectedLine)
            (event.target as Library.PokerInterface.RankingTunierLine).mc_background.gotoAndStop(1);
        this.layoutManager.customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
    }

    public getListFromServer(startR: number = -1, tournamentId: number = -1): void {
        var monthSort: number = int(this.monthComboBox.selectedId + 1);
        var yearSort: number = int(this.yearComboBox.selectedId + 2011);
        if (yearSort == 2011) {
            monthSort += int(9 - 1);
        }
        var paramObject: any = { startRank: startR, month: monthSort, year: yearSort, id: tournamentId };
        BasicModel.smartfoxClient.sendMessage("rjl", [JSON.stringify(paramObject)]);
    }

    private fillTournamentRanking(tournamentRanking: TournamentRankingVO[]): void {
        var count: number = 0;
        var timeStr: string;
        var tItem: Library.PokerInterface.RankingTunierLine;

        for (var i: number = 0; i < this.MAX_RANKINGLINES; i++) {
            tItem = castAs<Library.PokerInterface.RankingTunierLine>(this.disp["line" + i], "RankingTunierLine");
            if (tournamentRanking.length - 1 < i) {
                tItem.visible = false;
                continue;
            }
            tItem.mc_background.gotoAndStop(1);
            if (tItem == this.selectedLine && tournamentRanking[i].id == this.selectedTournament) {
                this.selectedLine.mc_background.gotoAndStop(2);
                count++;
            }

            if (i == 0) {
                this.disp.btn_up.properties = tournamentRanking[i].startRank;
                tItem.startRank = tournamentRanking[i].startRank;
            }
            else if (i == this.MAX_RANKINGLINES - 1) {
                this.disp.btn_down.properties = tournamentRanking[i].startRank;
            }

            tItem.visible = true;
            tItem.properties = tournamentRanking[i].id;
            timeStr = TimeStringHelper.getDateToString(tournamentRanking[i].date * 1000, TimeStringHelper.DATE_DAY_FORMAT, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
            tItem.txt_tables_0.text = timeStr;
            tItem.txt_tables_1.text = tournamentRanking[i].first;
            tItem.txt_tables_2.text = tournamentRanking[i].second;
            tItem.txt_tables_3.text = tournamentRanking[i].third;
            tItem.mouseChildren = false;
        }
    }

    private activateTournamentRankLine(table: Library.PokerInterface.RankingTunierLine): void {
        if (this.selectedLine != table) {
            if (this.selectedLine)
                this.selectedLine.mc_background.gotoAndStop(1);
            this.selectedLine = table;
            this.selectedLine.mc_background.gotoAndStop(2);
        }
    }

    //
    // getter & setter
    //

    protected get layoutManager(): Poker2LayoutManager {
        return Poker2LayoutManager.getInstance();
    }
    protected get controller(): BasicController {
        return BasicController.getInstance();
    }

    //
    // ende
    //
}
import { Poker2RankingDialog } from "../../dialogs/ranking/Poker2RankingDialog";
import { Poker2LayoutManager } from "../../Poker2LayoutManager";

import { castAs } from "@goodgamestudios/createjs-utilities";

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
import {Poker2DynamicCombobox} from "../Poker2DynamicCombobox";
